import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrolled > 80);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    const scrollToTop = () => {
      const c = document.documentElement.scrollTop || document.body.scrollTop;
      if (c > 0) {
        window.requestAnimationFrame(scrollToTop);
        window.scrollTo(0, c - c / 8);
      }
    };
    scrollToTop();
  };

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <button
      onClick={handleClick}
      className="back-to-top-react"
      style={{
        position: 'fixed',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '55px',
        height: '55px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #ff6b35 0%, #ff8c42 100%)',
        color: 'white',
        border: '3px solid white',
        cursor: 'pointer',
        fontSize: '28px',
        fontWeight: 'bold',
        zIndex: 9999999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 6px 20px rgba(255, 107, 53, 0.7)',
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) translateY(-5px) scale(1.1)';
        e.currentTarget.style.boxShadow = '0 8px 25px rgba(255, 107, 53, 0.9)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateX(-50%) translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(255, 107, 53, 0.7)';
      }}
    >
      ↑
    </button>,
    document.body
  );
};

export default BackToTop;
